import axios from "axios";
export const carlineLinkService = (options, featureServices) => {
    const { "s2:logger": logger, "gfa:locale-service": localeService } = featureServices;
    const AEM_PROD_BASE_URL = "https://web-api.audi.com/carlinelinks/v1/";
    const fetchJSON = async () => {
        // on PROD market specific, in demo-integrator it is carlineLinkEndpointUrl
        const endpoint = `${AEM_PROD_BASE_URL}${localeService.countryCode}/${localeService.language}`;
        const url = options.carlineLinkEndpointUrl ?? endpoint;
        return await axios
            .get(url)
            .then((result) => {
            if (result.status === 200) {
                logger.debug(`[audi-carline-link-service] successfully loaded ${url}`);
                return result.data.carlines;
            }
            else {
                throw new Error(`response status: ${result.status}`);
            }
        })
            .catch((err) => {
            logger.error(`[audi-carline-link-service] error loading ${url} - ${err.message}`);
        });
    };
    const getLinksForCarline = async (carline) => {
        const allCarlines = await fetchJSON();
        const spezificCarline = allCarlines[carline];
        if (spezificCarline !== null && spezificCarline !== undefined) {
            return spezificCarline;
        }
        else {
            throw new Error(`[audi-carline-link-service] no carline "${carline}" found`);
        }
    };
    return {
        getLinksForCarline,
    };
};
//# sourceMappingURL=v1.js.map